export default __webpack_public_path__ + "static/media/party-meagan.05ee1d19.jpg";